function getCurrentPage() {
    const pathname = window.location.pathname;  // Get the path
    const pageName = pathname.split("/").pop(); // Extract the file name
    return pageName;
}



document.addEventListener('DOMContentLoaded', function() {
    console.log(getCurrentPage());
});